<template>
  <adminTable
    :tableLoading="tableLoading"
    :totalList="totalList"
    v-model:page="page"
    v-model:limit="limit"
    v-model:searchForm="searchForm"
    :tableData="tableData"
    @search="getList"
  >
    <template v-slot:form-inline-items>
      <el-form-item>
        <el-input
          v-model="searchForm.phone"
          placeholder="请输入手机号码"
          clearable
        />
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="searchForm.level"
          placeholder="请输入层级"
          clearable
        />
      </el-form-item>
      <el-form-item>
        <el-select v-model="searchForm.blow" placeholder="上下级" clearable>
          <el-option label="下级" value="0" />
          <el-option label="上级" value="1" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="searchForm.is_test"
          placeholder="账号类型"
          clearable
        >
          <el-option
            v-for="item in accountTypeEnums"
            :label="item.label"
            :value="item.value"
            :key="item.label"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-col :span="11">
          <el-date-picker
            v-model="searchForm.starttime"
            type="datetime"
            value-format="YYYY-MM-DD HH:mm:ss"
            placeholder="开始时间"
            style="width: 100%"
          />
        </el-col>
        <el-col :span="2" class="text-center">
          <span class="text-gray-500">-</span>
        </el-col>
        <el-col :span="11">
          <el-date-picker
            v-model="searchForm.endtime"
            type="datetime"
            value-format="YYYY-MM-DD HH:mm:ss"
            placeholder="结束时间"
            style="width: 100%"
          />
        </el-col>
      </el-form-item>
    </template>
    <template v-slot:tableInfo>
      <div class="tableInfo">
        下级总充值：<span>{{ teamInfo.total_chongzhi }}</span> 下级总提现：
        <span>{{ teamInfo.total_tixian }}</span> 下级总投资：
        <span>{{ teamInfo.total_dingyue_jiner }} </span> 当前层级总人数：<span
          >{{ teamInfo.total_dingyue_ershu }}
        </span>
        当前等级充值人数：<span>{{ teamInfo.total_chongzhi_reshu }} </span>
      </div>
    </template>
    <template v-slot:table>
      <el-table-column prop="id" label="ID" width="60" />
      <el-table-column prop="sfz_name" label="用户名" width="100">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">{{
            scope.row.sfz_name
          }}</span>
          <el-tag v-if="scope.row.online" type="success">在线</el-tag>
          <p style="color: red;">{{ scope.row.remark }}</p>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="nickname" label="昵称" width="100" /> -->
      <el-table-column prop="phone" label="手机号码" width="100">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">{{ scope.row.phone }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="is_test" label="账号类型" width="130">
        <template #default="scope">
          {{ getLabelByVal(scope.row.is_test, accountTypeEnums) }}
        </template>
      </el-table-column>
      <el-table-column prop="invite" label="邀请码" width="70">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">{{ scope.row.invite }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="level_team_name" label="团队等级" width="70">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">{{ scope.row.level_team_name }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="level_name" label="用户等级" width="70">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">{{ scope.row.level_name }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="addtime" label="注册时间" width="220">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            注册时间：{{ scope.row.create_at }}
            <br />
            注册IP：{{ scope.row.register_ip }}
            <br />
            登录时间：{{ scope.row.login_time }}
            <br />
            登录地址：{{ scope.row.ip_address }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="会员统计" width="180">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            余额：{{ scope.row.money }} <br />
            冻结余额：{{ scope.row.frozen_money }}<br />
            <!-- 余额宝：{{ scope.row.yuebao_money }}<br /> -->
            充值金额：{{ scope.row.recharge_money }}<br />
            提现金额：{{ scope.row.withdraw_money }}<br />
            投资：{{ scope.row.invest_money }}<br />
            积分：{{ scope.row.user_points }}<br />
          </span>
        </template>
      </el-table-column>
      <el-table-column label="团队查看" width="180">
        <template #default="scope">
          <div class="link" @click="gotoTeamList(1, scope.row)">查看上级</div>
          <div class="link" @click="gotoTeamList(0, scope.row)">查看下级</div>
        </template>
      </el-table-column>
      <el-table-column
        v-if="currentUser.role == 0"
        fixed="right"
        prop="address"
        width="250"
        label="操作"
      >
        <template #default="scope">
          <div class="table-handle-td">
            <el-button
              type="primary"
              icon="Edit"
              v-permission
              @click="editItems('state', scope.row)"
              >状态</el-button
            >
            <el-button
              type="warning"
              icon="Wallet"
              v-permission
              @click="editItems('money', scope.row)"
              >金额</el-button
            >
            <el-button
              type="info"
              icon="User"
              v-permission
              @click="editItems('info', scope.row)"
              >信息</el-button
            >
            <el-button
              color="#626aef"
              @click="editItems('count', scope.row)"
              icon="Pointer"
              v-permission
              >统计</el-button
            >
            <el-button
              type="danger"
              @click="editItems('transfer', scope.row)"
              icon="Sort"
              v-permission
              >转移</el-button
            >
          </div>
        </template>
      </el-table-column>
    </template>
    <el-dialog
      v-model="dialogFlag"
      title="操作"
      :width="['levelOne', 'levelTwo'].includes(dialogType) ? '90%' : 1050"
    >
      <editUserForm
        :key="currentRow"
        v-if="dialogType === 'add' || dialogType === 'edit'"
        ref="editUserFormRef"
        :type="dialogType"
        :item="currentRow"
      />
      <userMoneyForm
        :key="currentRow"
        v-if="dialogType === 'money'"
        ref="userMoneyFormRef"
        :item="currentRow"
      />
      <userStateForm
        :key="currentRow"
        v-if="dialogType === 'state'"
        ref="userStateFormRef"
        :item="currentRow"
      />
      <userInfoForm
        :key="currentRow"
        v-if="dialogType === 'info'"
        ref="userInfoFormRef"
        :item="currentRow"
      />
      <userCountForm
        :key="currentRow"
        v-if="dialogType === 'count'"
        ref="userCountFormRef"
        :item="currentRow"
      />
      <userTransfer
        :key="currentRow"
        v-if="dialogType === 'transfer'"
        ref="transferFormRef"
        :item="currentRow"
      />
      <userLevelUpper
        :key="currentRow"
        v-if="dialogType === 'levelUpper'"
        ref="levelUpperRef"
        :item="currentRow"
      />
      <userLevelOne
        :key="currentRow"
        v-if="dialogType === 'levelOne'"
        ref="levelOneRef"
        :item="currentRow"
      />

      <userLevelTwo
        :key="currentRow"
        v-if="dialogType === 'levelTwo'"
        ref="levelTwoRef"
        :level="teamLevel"
        :item="currentRow"
      />
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="dialogFlag = false">关闭</el-button>
          <el-button type="primary" @click="submitForm"> 保存 </el-button>
        </div>
      </template>
    </el-dialog>
  </adminTable>
</template>

<script setup>
import { ref, getCurrentInstance, onMounted, reactive } from "vue";
import { useRoute, useRouter } from "vue-router";
import editUserForm from "./components/userList/editUserForm.vue";
import userMoneyForm from "./components/userList/userMoneyForm.vue";
import userStateForm from "./components/userList/userStateForm.vue";
import userInfoForm from "./components/userList/userInfoForm.vue";
import userCountForm from "./components/userList/userCountForm.vue";
import userTransfer from "./components/userList/userTransfer.vue";
import userLevelOne from "./components/userList/userLevelOne.vue";
import userLevelTwo from "./components/userList/userLevelTwo.vue";
import userLevelUpper from "./components/userList/userLevelUpper.vue";
import {
  sfzStatusEnums,
  accountTypeEnums,
  userlistSfzStatusEnums,
  booleanEnums,
  getLabelByVal,
} from "@/config/enums";
import { ElMessage, ElMessageBox } from "element-plus";

const currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
const searchForm = ref({
  phone: "",
  level: 99,
  blow: "",
  starttime: "",
  endtime: "",
  status: "",
  is_test: "",
});

const router = useRouter();
const route = useRoute();
onMounted(() => {
  if (route.query && route.query.phone) {
    searchForm.value.phone = route.query.phone;
  }

  if (route.query && route.query.blow) {
    searchForm.value.blow = route.query.blow;
  }
  getList();
});

const { proxy } = getCurrentInstance();

const page = ref(1);
const limit = ref(10);
const totalList = ref(0);
const tableLoading = ref(false);
const tableData = ref([]);

const dialogFlag = ref(false);
const dialogType = ref("add");
const currentRow = ref({});

const editUserFormRef = ref(null);
const userMoneyFormRef = ref(null);
const userStateFormRef = ref(null);
const userCountFormRef = ref(null);
const userInfoFormRef = ref(null);
const transferFormRef = ref(null);
const levelOneRef = ref(null);
const levelUpperRef = ref(null);
const levelTwoRef = ref(null);

const teamInfo = reactive({
  total_chongzhi: 0,
  total_chongzhi_reshu: 0,
  total_dingyue_ershu: 0,
  total_dingyue_jiner: 0,
  total_tixian: 0,
});
const getList = async () => {
  tableLoading.value = true;
  const res = await proxy.$http({
    type: "get",
    url: "/user/getTeamLists",
    params: {
      ...searchForm.value,
      page: page.value,
      limit: limit.value,
    },
  });
  tableLoading.value = false;
  if (res.code == 0) {
    tableData.value = res.data.data;
    totalList.value = res.data.total;
    Object.assign(teamInfo, res.data.team);
  }
};

const toList = (str, row) => {
  router.push(`${str}?phone=${row.phone}`);
};
const gotoTeamList = (blow, row) => {

  searchForm.value.phone = row.phone;
  searchForm.value.blow = blow + '';
  getList();
};

const editItems = (type, row = {}) => {
  currentRow.value = row;
  dialogType.value = type;

  dialogFlag.value = true;
};

const submitForm = async () => {
  if (dialogType.value == "money") {
    userMoneyFormRef.value.formRef.validate(async (valid) => {
      if (valid) {
        const data = userMoneyFormRef.value.form;
        const res = await proxy.$http({
          method: "post",
          url: "MoneyLog/addMoney",
          data: {
            uid: data.id,
            class_id: data.class_id,
            type: data.type,
            money: data.money3,
            desc: data.desc,
          },
        });
        dialogFlag.value = false;
        if (res.code == 0) {
          ElMessage({
            type: "success",
            message: res.msg,
          });
        } else {
          ElMessage({
            type: "error",
            message: res.msg,
          });
        }
        getList();
      }
    });
  } else if (dialogType.value == "add" || dialogType.value == "edit") {
    // 新增用户
    const url = dialogType.value == "add" ? "User/addUser" : "";
    const data = editUserFormRef.value.form;
    if (dialogType.value == "add") {
      data.id = null;
    }
    const res = await proxy.$http({
      method: "post",
      url: url,
      data: {
        // username: data.username,
        phone: data.phone,
        invite: data.invite,
        password: data.password,
      },
    });

    if (res.code == 0) {
      dialogFlag.value = false;
      getList();
      ElMessage({
        type: "success",
        message: res.msg,
      });
    } else {
      dialogFlag.value = false;
      ElMessage({
        type: "error",
        message: res.msg,
      });
    }
  } else if (dialogType.value == "state") {
    // 用户状态
    const data = userStateFormRef.value.form;
    const res = await proxy.$http({
      method: "post",
      url: "user/updateUserState",
      data: {
        uid: data.id,
        ban_buy: data.ban_buy,
        ban_sigin: data.ban_sigin,
        ban_raffle: data.ban_raffle,
        ban_login: data.ban_login,
        ban_invite: data.ban_invite,
        ban_recharge: data.ban_recharge,
        ban_withdraw: data.ban_withdraw,
        ban_exchange: data.ban_exchange,
        sfz_status: data.sfz_status,
        kick_out: data.kick_out,
        is_test: data.is_test,
        is_valid_user: data.is_valid_user,
      },
    });
    dialogFlag.value = false;
    if (res.code == 0) {
      ElMessage({
        type: "success",
        message: res.msg,
      });
    } else {
      ElMessage({
        type: "error",
        message: res.msg,
      });
    }
    getList();
  } else if (dialogType.value == "info") {
    // 用户信息
    const data = userInfoFormRef.value.form;
    const res = await proxy.$http({
      method: "post",
      url: "user/updateUser",
      data: {
        id: data.id,
        username: data.username,
        nickname: data.nickname,
        password: data.password,
        pin: data.pin,
        phone: data.phone,
        email: data.email,
        sfz_name: data.sfz_name,
        sfz_number: data.sfz_number,
        avatar: data.avatar,
        level: data.level,
        level_team: data.level_team,
        remark: data.remark
      },
    });
    dialogFlag.value = false;
    if (res.code == 0) {
      ElMessage({
        type: "success",
        message: res.msg,
      });
    } else {
      ElMessage({
        type: "error",
        message: res.msg,
      });
    }
    getList();
  } else if (dialogType.value == "count") {
    // 用户统计
    const data = userCountFormRef.value.form;
    const res = await proxy.$http({
      method: "post",
      url: "user/updateUserInfo",
      data: {
        id: data.id,
        uid: data.id,
        username: data.username,
        shares_money: data.shares_money,
        yuebao_money: data.yuebao_money,
        yuebao_earn: data.yuebao_earn,
        yuebao_time: data.yuebao_time,
        yuebao_num: data.yuebao_num,
        recharge_num: data.recharge_num,
        withdraw_money: data.withdraw_money,
        withdraw_num: data.withdraw_num,
        signin_money: data.signin_money,
        signin_num: data.signin_num,
        raffle_money: data.raffle_money,
        raffle_num: data.raffle_num,
        team_invite: data.team_invite,
        team_item: data.team_item,
        team_item_v1: data.team_item_v1,
        team_item_v2: data.team_item_v2,
        team_item_v3: data.team_item_v3,
        team_invite_v1: data.team_invite_v1,
        team_invite_v2: data.team_invite_v2,
        team_invite_v3: data.team_invite_v3,
        team_invite_num: data.team_invite_num,
        team_invite_user: data.team_invite_user,
        team_recharge: data.team_recharge,
        team_recharge_v1: data.team_recharge_v1,
        team_recharge_v2: data.team_recharge_v2,
        team_recharge_v3: data.team_recharge_v3,
        income_money: data.income_money,
        invest_money: data.invest_money,
        invest_not_finish: data.invest_not_finish,
        invest_num: data.invest_num,
        user_points: data.user_points,
        user_coupon: data.user_coupon,
        bonus_num: data.bonus_num,
        bonus_money: data.bonus_money,
      },
    });
    dialogFlag.value = false;
    if (res.code == 0) {
      ElMessage({
        type: "success",
        message: res.msg,
      });
    } else {
      ElMessage({
        type: "error",
        message: res.msg,
      });
    }
    getList();
  } else if (dialogType.value == "transfer") {
    const data = transferFormRef.value.form;
    const res = await proxy.$http({
      method: "post",
      url: "user/userRemove",
      data: {
        from_user: data.from_user,
        to_user: data.to_user,
        // lv: data.lv,
      },
    });

    if (res.code == 0) {
      dialogFlag.value = false;
      getList();
      ElMessage({
        type: "success",
        message: res.msg,
      });
    } else {
      dialogFlag.value = false;
      ElMessage({
        type: "error",
        message: res.msg,
      });
    }
  }
};
</script>

<style lang="less" scoped>
.tableInfo {
  text-align: left;
  padding: 10px 0;
  font-size: 14px;
  span {
    color: #409eff;
  }
}

::v-deep .header-form {
  border-bottom: none;
}

.table-handle-td {
  display: flex;
  cursor: pointer;
  flex-wrap: wrap;
  button {
    margin-bottom: 10px;
    margin-left: 0;
    margin-right: 10px;
  }
}
</style>
